import openSocket from 'socket.io-client';
import supportChatEmbedService from '../support.chat.embed.service';
import loginService from '../login.service';

const subscribers = new Set();
let socket;
let renewalTimer;
let connecting = false;
let generation = 0;

const notify = (event, payload) => subscribers.forEach(subscriber => subscriber[event]?.(payload));

const connect = async () => {
    if (connecting || !subscribers.size || !loginService.isCustomer()) return;
    connecting = true;
    const current = generation;
    try {
        const session = await supportChatEmbedService.createAuthenticatedSession();
        if (current !== generation || !subscribers.size) return;
        if (!session.token || !session.socketUrl) throw new Error('Request comments socket is not configured');
        const expiresAt = Date.parse(session.expiresAt);
        if (!Number.isFinite(expiresAt)) throw new Error('Invalid request comments session expiry');
        socket?.removeAllListeners();
        socket?.disconnect();
        socket = openSocket(session.socketUrl, {
            transports: ['websocket', 'polling'],
            reconnection: true,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 15000,
            timeout: 10000,
            query: { token: session.token }
        });
        socket.on('connect', () => socket.emit('joinRequestComments', result => {
            if (result?.success) notify('onConnect');
            else notify('onError');
        }));
        socket.on('requestCommentChanged', payload => notify('onChange', payload));
        socket.on('connect_error', () => notify('onError'));
        socket.on('disconnect', reason => {
            if (reason === 'io server disconnect') {
                notify('onError');
                clearTimeout(renewalTimer);
                renewalTimer = setTimeout(connect, 60000);
            }
        });
        clearTimeout(renewalTimer);
        renewalTimer = setTimeout(connect, Math.max(10000, expiresAt - Date.now() - 60000));
    } catch (error) {
        if (current === generation && subscribers.size) {
            notify('onError');
            clearTimeout(renewalTimer);
            renewalTimer = setTimeout(connect, 60000);
        }
    } finally {
        if (current === generation) connecting = false;
    }
};

const subscribe = subscriber => {
    subscribers.add(subscriber);
    if (!socket && !connecting) connect();
    return () => {
        subscribers.delete(subscriber);
        if (subscribers.size) return;
        generation += 1;
        connecting = false;
        clearTimeout(renewalTimer);
        socket?.removeAllListeners();
        socket?.disconnect();
        socket = undefined;
    };
};

const commentsRealtimeService = { subscribe };
export default commentsRealtimeService;
